// get offset in minutes compare to UTC => ex: UA will return -120 offset (+ 2 hours from UTC / GMT);
// return new unix timestamp in seconds
const getUTCTime = () => {
    const offset = new Date().getTimezoneOffset(); // get offset in minutes
    return timestamp => timestamp - offset * -60;
};

export default getUTCTime();
